import React, { useContext, useState } from "react";
import Modal from "../Modal/Modal";
import classes from "./AddBoard.module.scss";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

const AddBoardModal = () => {
  const { closeModal } = useContext(ModalContext);
  const { createNewBoard } = useContext(BoardContext);

  const [title, setTitle] = useState("");
  const [columnNames, setColumnNames] = useState(["Todo", "Doing", "Done"]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleColumnChange = (index, value) => {
    setColumnNames((prev) => prev.map((name, i) => (i === index ? value : name)));
  };

  const handleAddColumn = (e) => {
    e.preventDefault();
    setColumnNames((prev) => [...prev, ""]);
  };

  const handleRemoveColumn = (index) => {
    setColumnNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedTitle = title.trim();
    if (!trimmedTitle) {
      alert("Please enter a board name.");
      return;
    }
    setIsSubmitting(true);
    await createNewBoard(
      trimmedTitle,
      columnNames.map((name) => name.trim()).filter(Boolean)
    );
    setIsSubmitting(false);
    closeModal();
  };

  return (
    <Modal>
      <section className={`${classes.add_board}`}>
        <form onSubmit={handleSubmit}>
          <h1>Add New Board</h1>
          <section className={classes.name}>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </section>
          <section className={classes.board_columns}>
            <label>Columns</label>
            <section className={classes.board_column_names}>
              {columnNames.map((name, index) => (
                <div key={index}>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => handleColumnChange(index, e.target.value)}
                  />
                  <button
                    type="button"
                    aria-label={`Remove column ${name || index + 1}`}
                    className={classes.xMarkButton}
                    onClick={() => handleRemoveColumn(index)}
                  >
                    <FontAwesomeIcon icon={faX} className={classes.xMark} aria-hidden="true" />
                  </button>
                </div>
              ))}
            </section>
          </section>
          <button
            onClick={handleAddColumn}
            className={`${classes.add_new_column}`}
            disabled={isSubmitting}
          >
            +Add New Column
          </button>
          <button type="submit" className={classes.add_new_board} disabled={isSubmitting}>
            {isSubmitting ? "Creating…" : "Create New Board"}
          </button>
        </form>
      </section>
    </Modal>
  );
};

export default AddBoardModal;
